var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDecrement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.09961,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.09961,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 7.5,
    stroke: "#E8A3A3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62994 10.7197C8.33705 10.4268 7.86217 10.4268 7.56928 10.7197C7.27639 11.0126 7.27639 11.4874 7.56928 11.7803L10.8533 15.0643C12.0249 16.2359 13.9244 16.2359 15.0959 15.0643L15.6639 14.4963C16.2497 13.9105 17.1995 13.9105 17.7853 14.4963L21.2889 18H20.0996C19.6854 18 19.3496 18.3358 19.3496 18.75C19.3496 19.1642 19.6854 19.5 20.0996 19.5H23.0996C23.5138 19.5 23.8496 19.1642 23.8496 18.75V15.75C23.8496 15.3358 23.5138 15 23.0996 15C22.6854 15 22.3496 15.3358 22.3496 15.75V16.9393L18.8459 13.4357C17.6744 12.2641 15.7749 12.2641 14.6033 13.4357L14.0353 14.0037C13.4495 14.5895 12.4997 14.5895 11.9139 14.0037L8.62994 10.7197Z",
    fill: "#D14545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecrement);
export default __webpack_public_path__ + "static/media/decrement.4bd77b579fcff31dcaf49b2671eec31f.svg";
export { ForwardRef as ReactComponent };